// extracted by mini-css-extract-plugin
module.exports = {"portalNoScroll":"_3pbZUB2kzvTVNPDLpcwJf5"};